<section id="hero" class="hero">
  <div class="bg"></div>
  <div class="fade"></div>
  <div class="inner">
    <div class="wl-hero-grid">

      <div class="wl-hero-text">
        <p class="eyebrow">Interaktywne doświadczenie weselne</p>
        <h1 class="title">Koniec z żenującymi<br>zabawami weselnymi.</h1>
        <p class="sub">Cała sala bawi się razem - z własnego telefonu i&nbsp;miejsca przy stole. Bez wyciągania na parkiet, przymusu i żenady.</p>
        <div class="actions">
          <a routerLink="/admin/kreator" class="btn-primary">Zacznij za darmo</a>
        </div>
      </div>

      <div class="wl-hero-phone phone-area">
        <div class="phone-wrap">
          <div class="wl-phone-badge live-badge">
            <span class="live-dot"></span>182 grają na żywo
          </div>
          <div class="wl-phone-inner phone">
            <div class="notch-row"><div class="notch"></div></div>
            <div class="screen">
              <img src="images/hero-mock.png" alt="Wesele Live — ekran gry">
            </div>
          </div>
          <div class="wl-lboard lboard">
            <p class="lboard-label">Ranking sali</p>
            <div class="lboard-rows">
              <div class="lb-row"><span class="lb-rank top">1</span><div class="lb-track"><div class="lb-fill top" style="width: 90%;"></div></div></div>
              <div class="lb-row"><span class="lb-rank">2</span><div class="lb-track"><div class="lb-fill" style="width: 72%;"></div></div></div>
              <div class="lb-row"><span class="lb-rank">3</span><div class="lb-track"><div class="lb-fill" style="width: 56%;"></div></div></div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
